import lodash from 'lodash';


import { nextId } from '../../utils';


import expectedTicketNumberSetApi from './graphql/expectedTicketNumberSet';
import { getSelectedMissingTicketNumberId, getViewNotExpected } from './selectors';


export const types = {
  VIEW_MISSING: 'missingTicketNumbers/VIEW_MISSING',
  VIEW_NOT_EXPECTED: 'missingTicketNumbers/VIEW_NOT_EXPECTED',
  SELECT_MISSING_TICKET_NUMBER_ID: 'missingTicketNumbers/SELECT_MISSING_TICKET_NUMBER_ID',
};


export const viewMissing = () => {
  return {
    type: types.VIEW_MISSING,
  };
};


export const viewNotExpected = () => {
  return {
    type: types.VIEW_NOT_EXPECTED,
  };
};


export const selectMissingTicketNumberId = (selectedMissingTicketNumberId) => {
  return {
    type: types.SELECT_MISSING_TICKET_NUMBER_ID,
    selectedMissingTicketNumberId,
  };
};


export const expectedTicketNumberSet = (id, expected, reason) => {
  return async (dispatch, getState, { client }) => {
    const state = getState();
    const currentId = getSelectedMissingTicketNumberId(state);
    const onlyExpected = getViewNotExpected(state);
    const { newCollection, oldCollection } = await expectedTicketNumberSetApi(client, id, expected, reason, onlyExpected);

    const found = lodash.find(newCollection, (item) => { return item.id === currentId; });

    if (!found) {
      const next = nextId(oldCollection, currentId);
      dispatch(selectMissingTicketNumberId(next));
    }
  };
};
